import { lazyNamedComponent } from './utils/lazy-named-component';

export {
  ActivityDetailsView,
  ActivityListView,
  Asset3d,
  AssetDocuments,
  AssetProperties,
  AssetTrends,
  DataModelingOverridePage,
  IdmObservationsDesktopFormPage,
  IdmObservationsDesktopTablePage,
  IdmObservationsMobileListPage,
  IdmObservationMobileOverviewPage,
  LandingPage,
  NotificationDetailsView,
  PageNotFound,
  TemplateCreatedConfirmationPage,
  TemplatesMobile,
} from './shared-lazy-route-pages';

export const ActivityChecklistMobile = lazyNamedComponent(
  () => import('./activity/activity-checklist-mobile'),
  'ActivityChecklistMobile'
);

export const ActivityDesktop = lazyNamedComponent(
  () => import('./activity/activity-desktop/activity-desktop'),
  'ActivityDesktop'
);

export const ActivityPlanningView = lazyNamedComponent(
  () => import('./activity/activity-planning/activity-planning-view'),
  'ActivityPlanningView'
);

export const AppConfigView = lazyNamedComponent(
  () => import('./app-config/app-config-view'),
  'AppConfigView'
);

export const AssetActivities = lazyNamedComponent(
  () => import('./asset/asset-activities'),
  'AssetActivities'
);

export const AssetDetails = lazyNamedComponent(
  () => import('./asset/asset-details'),
  'AssetDetails'
);

export const AssetNotifications = lazyNamedComponent(
  () => import('./asset/asset-notifications'),
  'AssetNotifications'
);

export const ChecklistItemObservationListMobile = lazyNamedComponent(
  () =>
    import(
      './observation/checklist-item-observation-list-mobile/checklist-item-observation-list-mobile'
    ),
  'ChecklistItemObservationListMobile'
);

export const ObservationDetailsMobile = lazyNamedComponent(
  () => import('./observation/observation-details-mobile'),
  'ObservationDetailsMobile'
);

export const ObservationPageDesktop = lazyNamedComponent(
  () =>
    import('./observation/observation-page-desktop/observation-page-desktop'),
  'ObservationPageDesktop'
);

export const ObservationsOverview = lazyNamedComponent(
  () => import('./observation/observations-overview/observations-overview'),
  'ObservationsOverview'
);

export const PageLayout = lazyNamedComponent(
  () => import('./page-layout'),
  'PageLayout'
);

export const SchedulesPage = lazyNamedComponent(
  () => import('./schedules/schedules-page'),
  'SchedulesPage'
);

export const TemplatesOverviewNew = lazyNamedComponent(
  () => import('./template/templates-overview-new'),
  'TemplatesOverviewNew'
);

export const UserProfilePage = lazyNamedComponent(
  () => import('./user-profile-page/user-profile-page'),
  'UserProfilePage'
);
